// INFO: deprecated file

import React, { useCallback, useEffect, useState } from 'react'
import { Platform, StatusBar, StatusBarStyle } from 'react-native'
import { STAGE } from 'react-native-dotenv'
import { useFocusEffect } from '@react-navigation/native'
import { NativeStackScreenProps } from '@react-navigation/native-stack'
import { AnalyticsPayload, BusinessType, ThemesEnum, UserType } from '@vatom/experience-sdk'
import { BusinessSnapshot } from '@vatom/sdk/core'
import {
  Channels,
  useAccessToken,
  useAnalytics,
  useBusiness,
  useBusinessInventory,
  useBusinessProfile,
  useCampaignUserInfo,
  useNotificationsStore,
  useSDK,
  useUser,
  useUserInfo
} from '@vatom/sdk/react'
import { isVatom } from '@vatom/vatom/plugin'
import { LoaderView, theme } from '@vatom/wombo'
import { observer } from 'mobx-react-lite'
import { Box, View } from 'native-base'

import { TermsAndConditions } from '../../components/TermsAndConditions'
import { WebWrapper } from '../../components/WebWrapper'
import { AppRoutes, AppStackParamList } from '../../navigators'
import { useWalletConfig, useWalletSdkBusiness } from '../../utils/WalletSdk/hooks'

import { ThemeInterface } from './WebBusinessProvider/types'
// import BusinessHeader from './Partials/BusinessHeader'
// import { BusinessTabNavigator, businessTabRoutes } from './Partials/BusinessTabNavigator'
// import BusinessTokens from './Partials/BusinessTokens'
// import Share, { ShareOptions } from './Share'
// import { useWebView, WebBusinessProvider } from './WebBusinessProvider'

// const hosts = {
//   dev: 'https://sites.vatominc.cool/',
//   stage: 'https://sites.vatominc.cool/',
//   prod: 'https://sites.vatom.com/',
//   local: Platform.select({
//     android: 'http://10.0.2.2:3001/',
//     ios: 'http://localhost:3001/'
//   })
// } as const

// const host = hosts[STAGE as keyof typeof hosts] ?? hosts.dev

// export interface BusinessInterface {
//   business: BusinessSnapshot
//   theme: ThemeInterface
// }

// const BusinessPage = ({
//   tabInitialRouteName
// }: {
//   tabInitialRouteName?: keyof typeof businessTabRoutes
// }) => {
//   const { featureConfig, isEmbedded } = useWalletConfig()
//   const { businessId: sdkBusinessId } = useWalletSdkBusiness()
//   console.log('??? sdkBusinessId', sdkBusinessId, featureConfig, isEmbedded)
//   const { business, businessThemeName, businessTheme } = useWebView()
//   const pageConfig = business?.pageConfig

//   const [tab, setTab] = useState<{ style: StatusBarStyle; back: string }>({
//     style: 'dark-content',
//     back: theme.colors.white
//   })

//   useFocusEffect(
//     useCallback(() => {
//       if (businessThemeName === ThemesEnum.dark) {
//         setTab({
//           style: 'light-content',
//           back: businessTheme.backgroundRgba
//         })
//       }
//       return () => {
//         setTab({
//           style: 'dark-content',
//           back: theme.colors.white
//         })
//       }
//     }, [businessTheme.backgroundRgba, businessThemeName])
//   )

//   if (!business) return <LoaderView />

//   const wallet = {
//     id: 'wallet',
//     link: '/wallet',
//     src: '',
//     title: 'Wallet'
//   }

//   const customIcons = pageConfig?.features?.footer?.icons
//   const shouldRenderMicrosite = pageConfig?.features?.footer?.enabled
//   const icons = !shouldRenderMicrosite
//     ? undefined
//     : customIcons
//     ? [...customIcons, wallet]
//     : [wallet]

//   return (
//     <>
//       <StatusBar barStyle={tab.style} backgroundColor={tab.back} />

//       <View flex={1} background={businessTheme.backgroundRgba}>
//         <WebWrapper flex={undefined} safeAreaTop>
//           {!isEmbedded ||
//           (isEmbedded && !sdkBusinessId) ||
//           (isEmbedded && !featureConfig?.business?.hideHeader) ? (
//             <BusinessHeader icons={icons} />
//           ) : null}
//         </WebWrapper>
//         <Box bgColor={businessTheme.backgroundRgba} flex={1}>
//           {!shouldRenderMicrosite ? (
//             <BusinessTokens />
//           ) : (
//             <BusinessTabNavigator icons={icons} tabInitialRouteName={tabInitialRouteName} />
//           )}
//         </Box>
//       </View>
//     </>
//   )
// }

// export type BusinessPageProps = NativeStackScreenProps<AppStackParamList, 'business'>

// export default observer((props: BusinessPageProps) => {
//   const { data: businessFromProfile } = useBusinessProfile(props.route.params, STAGE)
//   const { data: businessFromBusiness } = useBusiness({ ...props.route.params, join: true })

//   const tabInitialRouteName = props.route.params?.tabInitialRouteName as
//     | keyof typeof businessTabRoutes
//     | undefined

//   const business =
//     businessFromProfile && businessFromBusiness
//       ? { ...businessFromProfile, ...businessFromBusiness }
//       : undefined

//   const businessInventory = useBusinessInventory(business?.id)
//   const pageConfig = business?.pageConfig
//   const user = useUser()
//   const AT = useAccessToken()
//   const { campaignUserInfo, fetchCampaignUserInfo } = useCampaignUserInfo(business)
//   const { userInfo, fetchUserInfo } = useUserInfo(business)
//   const sdk = useSDK()
//   const analytics = useAnalytics()
//   // TODO: readd this from business selector refactor
//   useEffect(() => {
//     if (!business || !businessInventory?.tokens.length) {
//       return
//     }
//     const autoOpen = business.pageConfig?.features?.vatom?.autoOpen ?? []
//     const autoOpenChannel = useNotificationsStore.getState().channels[Channels.autoOpen]

//     const hasPendingAutoOpens = autoOpen.some(id => {
//       return !autoOpenChannel?.find(obj => obj.objectDefinitionId === id)
//     })

//     if (!hasPendingAutoOpens) {
//       return
//     }
//     const tokenToOpen = businessInventory?.tokens?.find(token => {
//       const result =
//         token.studioInfo?.objectDefinitionId &&
//         autoOpen.includes(token.studioInfo?.objectDefinitionId) &&
//         autoOpenChannel.find(obj => obj.id === token.id) === undefined
//       return !!result
//     })

//     if (!tokenToOpen || !tokenToOpen.studioInfo?.objectDefinitionId) {
//       return
//     }

//     useNotificationsStore.getState().addNotification(Channels.autoOpen, {
//       id: tokenToOpen.id,
//       objectDefinitionId: tokenToOpen.studioInfo?.objectDefinitionId
//     })

//     props.navigation.navigate(AppRoutes.NFTDetail_Business, {
//       tokenId: tokenToOpen.id,
//       business: business?.id
//     })

//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [businessInventory.tokens, props.navigation])

//   const updatePoints = async () => {
//     const points = await sdk.vatomIncApi.getUserPoints(
//       user?.sub ? user.sub : '',
//       business?.defaultCampaignId ?? ''
//     )

//     return points
//   }
//   const updateUserCampaignInfo = async (payload: any) => {
//     if (AT && business) {
//       await sdk.vatomIncApi.updateUserCampaignInfo(payload, business, AT)
//       await fetchCampaignUserInfo()
//     }
//   }

//   const onAnalytics = (p: AnalyticsPayload) => {
//     const { type, payload } = p
//     const businessId = business?.id ?? ''
//     const campaignId = business?.defaultCampaignId ?? ''
//     analytics.event(type, { businessId, campaignId, ...payload })
//   }

//   useEffect(() => {
//     if (business) onAnalytics({ type: 'openBusiness' })
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [])

//   const onShare = async (options: ShareOptions) => {
//     const response = await Share.open(options)
//     return response
//   }

//   if (!business) {
//     return <LoaderView />
//   }

//   return (
//     <WebBusinessProvider
//       businessTokens={businessInventory.tokens}
//       navigation={props.navigation}
//       theme={themeBussines(pageConfig?.theme.pageTheme ?? 'light')}
//       business={business as BusinessType}
//       user={user as UserType}
//       accessToken={AT}
//       campaignUserInfo={campaignUserInfo}
//       updatePoints={updatePoints}
//       onAnalytics={onAnalytics}
//       updateUserCampaignInfo={updateUserCampaignInfo}
//       host={host}
//       onShare={onShare}
//       userInfo={userInfo}
//       fetchUserInfo={fetchUserInfo}
//     >
//       <BusinessPage tabInitialRouteName={tabInitialRouteName} />
//     </WebBusinessProvider>
//   )
// })

export const themeBussines = (t: ThemesEnum | string): ThemeInterface => {
  if (t === ThemesEnum.dark) {
    return {
      backgroundRgba: 'rgb(35,35,35);',
      background: '#111111',
      borderColor: 'rgb(134, 142, 150)',
      colorHeader: 'white',
      active: 'white',
      inactive: '#868e96',
      disabled: '#29313a'
    }
  }

  return {
    backgroundRgba: 'white',
    background: 'white',
    borderColor: '#EFEFEF',
    colorHeader: theme.colors.normalText,
    active: theme.colors.darkText,
    inactive: theme.colors.lightText,
    disabled: theme.colors.extraLightText
  }
}
